import { AbandonmentRateSection } from './AbandonmentRateSection';
import { AgentAdherenceSection } from './AgentAdherenceSection';
import { AgentOccupancySection } from './AgentOccupancySection';
import { AverageHandleTimeSection } from './AverageHandleTimeSection';
import { AverageQueueAnswerTimeSection } from './AverageQueueAnswerTimeSection';
import { ContactsHandledSection } from './ContactsHandledSection';
import { ServiceLevelSection } from './ServiceLevelSection';
import { DeflectionRateSection } from './DeflectionRateSection';
import { FirstContactResolutionSection } from './FirstContactResolutionSection';
import { LiveAgentStatusWidget } from './LiveAgentStatusWidget';
import { QueueStatusWidget } from './QueueStatusWidget';
import { AverageWrapTimeSection } from './AverageWrapTimeSection';
import { AverageHoldTimeSection } from './AverageHoldTimeSection';
import { Stack } from '@gapartners/ui';

export function DashboardSummary() {
  return (
    <Stack spacing={3}>
      <LiveAgentStatusWidget />

      <QueueStatusWidget />

      <AgentOccupancySection />

      <AgentAdherenceSection />

      <ContactsHandledSection />

      <AbandonmentRateSection />

      <AverageHandleTimeSection />

      <AverageWrapTimeSection />

      <AverageHoldTimeSection />

      <AverageQueueAnswerTimeSection />

      <ServiceLevelSection />

      <DeflectionRateSection />

      <FirstContactResolutionSection />
    </Stack>
  );
}
